import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPolygon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 7,
	height: 5,
	viewBox: "0 0 7 5",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.40192 4.5C4.01702 5.16667 3.05477 5.16667 2.66987 4.5L0.0717969 -6.05683e-07L7 0L4.40192 4.5Z",
		fill: "black",
		fillOpacity: .7
	})
});
export default SvgIconPolygon;
